export default function Breadcrumb({ items, ariaLabel = "Fil d’ariane", badges }) {
  const list = Array.isArray(items) ? items.filter(Boolean) : [];
  if (!list.length) return null;

  return (
    <nav className="Breadcrumb" aria-label={ariaLabel} role="navigation">
      <ol className="BreadcrumbList">
        {list.map((it, idx) => {
          const key = String(it.key || it.href || it.label || idx);
          const isLast = idx === list.length - 1;
          const label = String(it.label || "");
          const hasDnD = Boolean(it.onDrop || it.onDragOver || it.onDragEnter || it.onDragLeave);
          const disabled = Boolean(it.disabled) || (isLast && !it.onClick && !it.href && !hasDnD);
          const extraClass = String(it.className || "").trim();
          const commonProps = {
            className: `CrumbButton ${isLast ? "is-current" : ""} ${
              disabled ? "is-disabled" : ""
            } ${extraClass}`,
            title: it.title || label,
            onDragEnter: it.onDragEnter,
            onDragOver: it.onDragOver,
            onDragLeave: it.onDragLeave,
            onDrop: it.onDrop,
          };
          return (
            <li key={key} className="BreadcrumbItem">
              {idx > 0 ? (
                <span className="BreadcrumbSep" aria-hidden="true">
                  /
                </span>
              ) : null}
              {it.href && !disabled ? (
                <a {...commonProps} href={it.href}>
                  {label}
                </a>
              ) : it.onClick && !disabled ? (
                <button
                  {...commonProps}
                  type="button"
                  onClick={it.onClick}
                >
                  {label}
                </button>
              ) : (
                <button
                  {...commonProps}
                  type="button"
                  disabled={disabled && !hasDnD}
                >
                  {label}
                </button>
              )}
            </li>
          );
        })}
      </ol>
      {badges ? <div className="BreadcrumbBadges">{badges}</div> : null}
    </nav>
  );
}
